var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var flex = { display: "flex" };
export var fc = __assign(__assign({}, flex), { flexDirection: "column" });
export var fr = __assign(__assign({}, flex), { flexDirection: "row" });
export var fcenter = __assign(__assign({}, flex), { alignItems: "center", justifyContent: "center" });
export var ffill = __assign(__assign({}, flex), { alignItems: "stretch", justifyContent: "space-around" });
export var fstart = __assign(__assign({}, flex), { alignItems: "center", justifyContent: "flex-start" });
export var fullscreen = { height: "100vh", left: 0, position: "fixed", top: 0, width: "100vw", zIndex: 1 };
export var colors = {
    orange: "#e31d48",
    purple: "#3c1d4a",
    white: "#fff",
};
export var rounded = { borderRadius: "1vw" };
export var bg = function (color) { return ({ backgroundColor: color }); };
export var whitewash = { backgroundColor: "rgba(255, 255, 255, 0.4" };
export var pad = function (size) { return ({ padding: size }); };
export var rel = { position: "relative" };
export var abs = { position: "absolute" };
